export const NAV_TRANSITION_DURATION_FUNC = '0.25s ease-out';
export const NAV_TRANSITION_DURATION_FUNC_OPACITY = '0.15s ease-out';
